import Consumer, { ConsumerObject } from 'consumerjs';

class Exposition extends ConsumerObject {
}


export class ExpositionConsumer extends Consumer {
    constructor(endpoint='/api/exposition/', objectClass=Exposition) {
        super(endpoint, objectClass);
    }

    getExpositionPeriods(id, month, amount_of_months) {
        return this.get(`${id}/`, {include_exposition_periods: month, 'amount_of_months': amount_of_months});
    }
}



// WEBPACK FOOTER //
// ./src/my_artis/js/data/expositions/exposition.js